import { SET_VERSAO_SELECIONADA } from '../actions/actionTypes';

const initialState = {
    versao: {},
};

export const versaoReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_VERSAO_SELECIONADA:
            return {
                ...state,
                versao: action.versao,
            };

        default:
            return state;
    }
};
